import { useReveal } from "../../hooks/useReveal";
import { useI18n } from "../../i18n/useI18n";

export function TropicalVsSidereal() {
  const scope = useReveal<HTMLElement>();
  const { t } = useI18n();
  const c = t.compare;

  return (
    <section id="compare" ref={scope} className="relative py-24 md:py-32">
      <div className="container-lux">
        <div className="mx-auto max-w-2xl text-center">
          <p className="eyebrow mb-4" data-reveal>{c.eyebrow}</p>
          <h2 className="text-3xl font-semibold md:text-5xl" data-reveal>{c.title}</h2>
        </div>

        {/* 3 detailed paragraphs */}
        <div className="mx-auto mt-12 max-w-3xl space-y-6">
          {c.paragraphs.map((p, i) => (
            <p key={i} data-reveal className="text-lg leading-relaxed text-slate2/80">
              {p}
            </p>
          ))}
        </div>

        {/* Side-by-side comparison */}
        <div className="mx-auto mt-14 grid max-w-4xl gap-6 md:grid-cols-2">
          <div data-reveal className="rounded-3xl border border-slate-200/80 bg-white/70 p-8 shadow-sm">
            <h3 className="text-xl font-semibold text-slate-500">{c.tropicalLabel}</h3>
            <ul className="mt-4 space-y-3">
              {c.tropicalPoints.map((pt) => (
                <li key={pt} className="flex items-start gap-2 text-slate2/70">
                  <span className="mt-1 text-slate-400">✕</span>
                  <span>{pt}</span>
                </li>
              ))}
            </ul>
          </div>
          <div data-reveal className="rounded-3xl border border-gold/40 bg-white/80 p-8 shadow-xl shadow-amber-900/5">
            <h3 className="text-xl font-semibold text-gold-deep">{c.siderealLabel}</h3>
            <ul className="mt-4 space-y-3">
              {c.siderealPoints.map((pt) => (
                <li key={pt} className="flex items-start gap-2 text-charcoal">
                  <span className="mt-1 text-gold">✦</span>
                  <span>{pt}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
